import { appLogo } from '@/assets/images';
import { Stack } from '@/components/layout';
import { AppHeader } from '@/components/layout/app-header';
import { PlayerListTemplateV2 } from '@/components/template/player-list';
import { Image, Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { CreateProfileButton as CreateProfileButtonMobile } from '@/features/player/components/list-player/list-players-header/list-players-header-mobile';
import { CreateProfileButton as CreateProfileButtonTablet } from '@/features/player/components/list-player/list-players-header/list-players-header-tablet';
import { PlayerCard } from '@/features/player/components/list-player/player-card/player-card';
import { useListPlayer } from '@/features/player/hooks/use-list-player';
import { createStyles, useScaling } from '@/hooks';
import { useSessionStore } from '@/stores';
import { colors } from '@/theme/colors';
import React from 'react';

const renderPlayerCard = ({ item }: { item: player.PlayerLookupData; index: number }) => (
  <PlayerCard player={item} />
);

export const ListPlayersScreen = () => {
  const userUid = useSessionStore(s => s.user?.uid);

  return (
    <PlayerListTemplateV2.Providers userUid={userUid}>
      <ListPlayersScreenContent />
    </PlayerListTemplateV2.Providers>
  );
};

function ListPlayersScreenContent() {
  const { scale, isTablet } = useScaling();
  const styles = useStyles();
  const listPlayerLogic = useListPlayer();

  return (
    <PlayerListTemplateV2.Root
      listLogic={listPlayerLogic}
      loadingText={STRINGS.player.listPlayers.loadingPlayers}>
      <PlayerListTemplateV2.Header>
        <AppHeader backgroundColor="white">
          <AppHeader.Left>
            <Image
              source={appLogo}
              width={scale({ phone: 57, tablet: 60 })}
              height={scale({ phone: 28, tablet: 30 })}
              resizeMode="contain"
            />
          </AppHeader.Left>

          <AppHeader.Title>
            <Text
              variant={
                isTablet
                  ? 'Font Inter/Subtitle/Bold 14px'
                  : 'Font Montserrat/Subtitle/Subtitle 2 Bold 12px'
              }
              transform="uppercase"
              fontWeight={isTablet ? undefined : '800'}
              style={styles.headerTitle}>
              {STRINGS.player.listPlayers.title}
            </Text>
          </AppHeader.Title>

          <AppHeader.Right>
            <Stack
              width={scale({ phone: 57, tablet: 60 })}
              height={scale({ phone: 28, tablet: 30 })}
            />
          </AppHeader.Right>
        </AppHeader>
      </PlayerListTemplateV2.Header>

      <PlayerListTemplateV2.Toolbar
        titleResultsSummary={STRINGS.player.listPlayers.resultsSummaryTitleTablet}>
        <PlayerListTemplateV2.SearchBar />
        <PlayerListTemplateV2.Filter />
        <PlayerListTemplateV2.Pagination />
        <PlayerListTemplateV2.ActionButton
          mobile={<CreateProfileButtonMobile />}
          tablet={<CreateProfileButtonTablet />}
        />
      </PlayerListTemplateV2.Toolbar>

      <PlayerListTemplateV2.List
        renderItem={renderPlayerCard}
        numberOfColumns={{ phone: 1, tablet: 3 }}
        waitForInitialLayout
        // drawDistance={2000}
        gap={scale({
          phone: 12,
          tablet: 16,
        })}
      />
    </PlayerListTemplateV2.Root>
  );
}

const useStyles = createStyles(() => ({
  headerTitle: {
    color: colors.Blue,
  },
}));
